import { sourcePoint as T, hashCodeOf as W } from "@sunrise/shared";
import { isEmpty as $ } from "lodash-es";
import { toRaw as H, getCurrentInstance as F, onServerPrefetch as J } from "vue";
import { defineStore as Y } from "@sunrise/pinia";
function s(e) {
  return new Promise(function(t, n) {
    e || n();
    const i = new Image();
    i.onload = t, i.onerror = n, i.src = e;
  });
}
const O = "uberall", N = "h433pynae6ysqjyewft4q3abtuufnsyfdvpryj684x6gkdurbsne3x4u8tv29847", z = "Uberall GmbH";
let p = !1;
function Q(e) {
  if (!p)
    return Promise.resolve();
  const t = e.index + 1, n = Date.now(), i = `https://trk.uberall.com/trk?trkId=${N}&ids=${e.id}&type=CLICK&location=${e.location}&position=${t}&reloader=${n}`;
  return s(i).then(() => {
  });
}
function X(e) {
  Z(() => {
    if (e.length === 0)
      return;
    const t = e.map((c) => c.id).join(","), n = e.map((c) => c.index + 1).join(","), i = Date.now(), o = e[0].location, r = `https://trk.uberall.com/trk?trkId=${N}&ids=${t}&type=IMPRESSION&location=${o}&position=${n}&reloader=${i}`;
    s(r);
  });
}
function Z(e) {
  T.onConsentAvailable(() => {
    T.loadCustomVendorConsents((t, n) => {
      p = n && t.consentedVendors.filter((i) => i.name === z).length > 0, n && p && e();
    });
  });
}
function ve(e, t, n) {
  return {
    id: O,
    data: {
      id: e.partnerTrackingId,
      index: t,
      location: n.location.name
    }
  };
}
function ee() {
  return {
    id: O,
    click: Q,
    pageView: X
  };
}
const v = "yext", S = "KSIqiesqP8";
function te(e) {
  const t = e.index + 1, n = Date.now(), i = `https://pixel.yext-pub.com/plpixel?pid=${S}&ids=${e.id}&action=click&queryLocation=${e.location}&rank=${t}&source=serp&reloader=${n}`;
  return s(i).then(() => {
  });
}
function ne(e) {
  if (e.length === 0)
    return;
  const t = e.map((c) => c.id).join(","), n = e.map((c) => c.index + 1).join(","), i = Date.now(), o = e[0].location, r = `https://pixel.yext-pub.com/plpixel?pid=${S}&ids=${t}&action=impression&queryLocation=${o}&rank=${n}&source=serp&reloader=${i}`;
  s(r);
}
function Se(e, t, n) {
  return {
    id: v,
    data: {
      id: e.partnerTrackingId,
      location: n.location.name,
      index: t
    }
  };
}
function ie() {
  return {
    id: v,
    click: te,
    pageView: ne
  };
}
var oe = /* @__PURE__ */ ((e) => (e.HEADER_NAVI = "ed00000041", e.HEADER_BOOKMARKS_OPEN = "ed0000244", e.BRANCHENBUCH_RESULTLIST_DB_BUTTON = "ed0000047", e.STICKY_NAVIGATION = "ed0000099", e))(oe || {});
const L = Y("tracking", {
  state: () => ({
    trackings: {}
  }),
  actions: {
    addTracking(e, t) {
      this.trackings[e] = t;
    }
  }
});
var m = /* @__PURE__ */ ((e) => (e[e.VIEW = 1] = "VIEW", e[e.CLICK = 2] = "CLICK", e))(m || {}), l = /* @__PURE__ */ ((e) => (e.MOBILE = "mobile", e.DESKTOP = "desktop", e))(l || {});
const P = "mlm";
let I;
const d = {};
let re = 0;
function ce() {
  return I = I || V(), I;
}
function V() {
  return Math.round(Math.random() * Date.now() * 1e-3);
}
function x(e) {
  return e.items[0].id;
}
function ae(e) {
  const t = x(e);
  return !!Object.keys(d).find((i) => d[i] === t);
}
function se(e, t) {
  const n = x(e);
  d[t] = n, setTimeout(() => delete d[t], 1e3);
}
function A(e, t) {
  var i, o, r;
  const n = window.__pinia__.globalState.requestContext;
  return {
    referrer: document.referrer,
    page: e.page,
    display: {
      presentation: n.device.mobile ? l.MOBILE : l.DESKTOP
    },
    eventId: V(),
    viewId: ce(),
    user: {
      sessionId: ((i = window.utag_data) == null ? void 0 : i.tealium_session_id) || ""
    },
    itemChannel: e.itemChannel,
    placement: {
      componentId: e.componentId,
      pageUrl: e.pageUrl,
      affiliateId: e.affiliateId,
      items: e.items
    },
    testVariant: {
      id: ((o = n.abTest) == null ? void 0 : o.id) || "",
      variant: ((r = n.abTest) == null ? void 0 : r.variant) || ""
    },
    actionId: e.actionId || t
  };
}
function R(e) {
  const t = window.__pinia__.globalState.publicServices.mlm, n = JSON.stringify(e), i = btoa(Math.random() + "fublock");
  return `${t}/track?${i}&data=${encodeURI(btoa(n))}`;
}
function M(e) {
  return !e || !e.affiliateId || $(e.items);
}
function D(e) {
  if (M(e))
    return console.warn("Given tracking data is not valid", e), Promise.reject();
  if (ae(e))
    return Promise.reject();
  se(e, ++re);
  const t = A(e, m.CLICK);
  return s(R(t));
}
function K(e) {
  if (M(e))
    return console.warn("Given tracking data is not valid", e), Promise.reject();
  const t = A(e, m.VIEW);
  return s(R(t));
}
function ue(e, t) {
  return {
    id: P,
    data: e,
    when: t
  };
}
function j() {
  return {
    id: P,
    click: D,
    pageView: (e) => e.forEach(K)
  };
}
const Le = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  ActionId: m,
  DisplayType: l,
  createMlmTracking: ue,
  getIntegration: j,
  trackClick: D,
  trackView: K
}, Symbol.toStringTag, { value: "Module" })), G = "tealium", a = "not_set", le = {
  mslayer_element_data_id: a,
  mslayer_element_text: a,
  mslayer_element_type_text: a,
  mslayer_element_count: a,
  mslayer_element_variant: a,
  mslayer_element_body_type: a,
  mslayer_element_position: a,
  mslayer_element_id: a,
  mslayer_affiliate_id: a,
  mslayer_element_company_name: a,
  mslayer_element_detail_start_date: a
};
function de(e) {
  return Object.assign({}, le, e);
}
function B(e) {
  return new Promise((t) => {
    window.utag.link(e), setTimeout(t, 150);
  });
}
function Pe(e) {
  return {
    id: G,
    data: e
  };
}
function fe(e) {
  const t = window.utag && window.utag.link && typeof window.utag.link == "function";
  return !e || !t ? Promise.resolve() : B(e);
}
function Ve(e) {
  return fe(de(e));
}
function me() {
  return {
    id: G,
    click: B
  };
}
const _ = "useraction";
var U = /* @__PURE__ */ ((e) => (e.CLICK = "CLICK", e.IMPRESSION = "IMPRESSION", e))(U || {});
function g(e, t, n) {
  const i = `?service=useraction&channel=${e}&id=${t}&action=${n}`;
  return s(i).then(() => {
  });
}
function Ie(e) {
  return g(
    e.channel,
    e.id,
    "CLICK"
    /* CLICK */
  );
}
function pe(e) {
  e.forEach((t) => g(
    t.channel,
    t.id,
    "IMPRESSION"
    /* IMPRESSION */
  ));
}
function ke(e, t) {
  return {
    id: _,
    data: e,
    when: t
  };
}
function q() {
  return {
    id: _,
    click: Ie,
    pageView: pe
  };
}
const xe = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  ActionType: U,
  INTEGRATION_ID: _,
  createUserActionTracking: ke,
  getIntegration: q,
  track: g
}, Symbol.toStringTag, { value: "Module" }));
function _e() {
  const e = [
    me(),
    ie(),
    ee(),
    j(),
    q()
  ], t = {};
  return e.forEach((n) => {
    t[n.id] = n;
  }), t;
}
var w = /* @__PURE__ */ ((e) => (e[e.CLICK = 0] = "CLICK", e[e.PAGE_VIEW = 1] = "PAGE_VIEW", e[e.ELEMENT_VIEW = 2] = "ELEMENT_VIEW", e))(w || {});
let k, f;
function Ae(e, t) {
  k = L(e).trackings, f = {
    ..._e(),
    // default implementations may be overwritten by configured ones
    ...t || {}
  }, document.body.addEventListener("click", b), document.body.addEventListener("auxclick", b), be(k, f);
}
function ge(e) {
  return e.type === "auxclick";
}
function we(e) {
  return E(e) && !e.dataset.trackingId;
}
function b(e) {
  let t = e.target;
  for (; t && t.tagName !== "BODY" && !we(t); ) {
    if (t.dataset.trackingId) {
      he(e, t);
      break;
    }
    t = t.parentElement;
  }
}
function E(e) {
  return !!(e && (e.href || e.tagName.toUpperCase() === "A"));
}
function Ee() {
  try {
    window.stop();
  } catch {
    try {
      document.execCommand("Stop");
    } catch {
    }
  }
}
function y(e) {
  return E(e) ? (Ee(), window.location.assign(e.href), !0) : !1;
}
function he(e, t) {
  if (t.dataset && t.dataset.trackOnce === "clicked" || !t.dataset.trackingId)
    return;
  const n = k[t.dataset.trackingId];
  if (n)
    return Ce(e, t, H(n));
}
function Ce(e, t, n) {
  let i = !1;
  const o = n.filter((u) => f[u.id] && Te(u));
  if ($(o))
    return;
  t.target !== "_blank" && !ge(e) && E(t) ? e.preventDefault() : i = !0;
  const r = setTimeout(function() {
    i || (i = y(t));
  }, 500), c = o.map((u) => {
    var h, C;
    return (C = (h = f[u.id]).click) == null ? void 0 : C.call(h, u.data);
  });
  Promise.all(c).catch(console.warn).finally(function() {
    clearTimeout(r), i || (i = y(t));
  }), "trackOnce" in t.dataset && (t.dataset.trackOnce = "clicked"), t.target === "_blank" && (i = !0);
}
function Te(e) {
  return e.when === w.CLICK || !e.when;
}
function be(e, t) {
  const n = {};
  e && (Object.values(e).flat(1).filter((i) => i.when === w.PAGE_VIEW).forEach((i) => {
    n[i.id] || (n[i.id] = []), n[i.id].push(i.data);
  }), Object.entries(n).forEach(([i, o]) => {
    var r, c;
    t[i] && t[i].pageView ? (c = (r = t[i]).pageView) == null || c.call(r, o) : console.warn(`No tracking integration found for ${i}. These trackings are skipped.`);
  }));
}
function Re(e) {
  var i, o, r;
  if (!e || e.length === 0)
    return {};
  const t = F();
  let n = (r = (o = (i = t == null ? void 0 : t.proxy) == null ? void 0 : i.$el) == null ? void 0 : o.dataset) == null ? void 0 : r.trackingId;
  return n || (n = (t == null ? void 0 : t.uid) + W(JSON.stringify(e))), J(() => {
    L().addTracking(n, e);
  }), {
    "data-tracking-id": n
  };
}
export {
  oe as ElementTrackingIds,
  Le as MLM,
  a as NOT_SET,
  w as TrackingType,
  xe as UserAction,
  Re as addTracking,
  Pe as createTealiumTracking,
  ve as createUberallTracking,
  Se as createYextTracking,
  de as mergeWithBaseTracking,
  Ae as setup,
  fe as track,
  Ce as trackLink,
  Ve as trackWithBaseTracking
};
//# sourceMappingURL=index.js.map
